<template>
	<div class="myCont">
		<div class="main">
			<div class="infosearch">
				<el-input v-model="keyName" placeholder="输入会员姓名/手机号查询" @keyup.native='specialCharacter' style="width: 284px;margin-right: 10px"></el-input>
				<el-button class="searchBtn" @click="enterSeach"></el-button>
				<el-button class="addMems" @click="addMemes">添加会员</el-button>
        <el-button class="addMems fr" @click="addBase">会员批量导入</el-button>
			</div>
			<el-table
				v-if="tableData.length > 0"
				:data="tableData"
				height='601'
				ref="multipleTable"
        :cell-class-name="tableRowClassName"
        @cell-click="linkToDetail"
				@row-dblclick="linkTo"
				class="myMemTable"
				style="width: 100%" :header-cell-style="{background:'#EFF1F5'}">
				<el-table-column align="center" type="index" label="序号" width="80"></el-table-column>
				<el-table-column align="center" prop="name" label="会员姓名">
          <template slot-scope="scope">
						{{scope.row.name | filterRow}}
					</template>
        </el-table-column>
				<el-table-column align="center" prop="phone" label="会员手机号"></el-table-column>
				<el-table-column align="center" prop="memberBirth" label="会员生日"></el-table-column>
				<el-table-column align="center" prop="source" label="来源">
					<template slot-scope="scope">
						{{scope.row.source | filterSource | filterRow}}
					</template>
				</el-table-column>
				<el-table-column align="center" prop="createTimeOff" label="注册/登记时间">
					<template slot-scope="scope">
						{{($route.params.type == 'birthday' ? scope.row.createTime : scope.row.createTimeOff) | formatDateLine | filterRow}}
					</template>
				</el-table-column>
				<el-table-column align="center" label="操作" class-name="operation" width="280">
					<template slot-scope="scope">
            <el-button size="mini" type="success" @click="serviSurplus(scope.row)">服务剩余</el-button>
						<el-button size="mini" type="danger" @click="editMem(scope.row.memberId)">修改</el-button>
						<el-button size="mini" class="darkBtn" @click="toDetail(1,scope.row)" >服务记录</el-button>
						<el-button size="mini" type="primary" @click="toDetail(2,scope.row)" >购买记录</el-button>
					</template>
				</el-table-column>
			</el-table>
			<template v-else>
				<div class="defaults" v-if="!mySearchflag">输入会员姓名或会员手机号，查询会员信息。</div>
				<div class="emptys" v-else>查不到会员信息！再核对一下试试</div>
			</template>

			<el-pagination  v-if=total
        @size-change="handleSizeChange"
				@current-change="handleCurrentChange"
				:current-page="currentPage"
				:page-sizes="[10, 20, 30, 40]"
				:page-size="pageSize"
				background
				layout="total, sizes, prev, pager, next, jumper"
				:total="total" style="margin-top: 20px;text-align:right">
			</el-pagination>

      <el-dialog :title="recordType.type == 1?'服务记录':'购买记录'" :visible.sync="dialogRecordVisible" :center="true" top="60px" width="1000px" >
        <infoRecord :dialogRecordVisible='dialogRecordVisible' :serviceRow='recordType' @closeDialog="closeDialog" />
      </el-dialog>
		</div>
	</div>
</template>
<script type="text/javascript">
import infoRecord from './inforecord'
import { searchMem, queryMemberBirthPage, sendCode } from "@/api";
import {formatDate} from '@/components/common/js/date.js';
import vFilter from "@/assets/js/filter";
import Vue from "vue";
for (let key in vFilter) {
  Vue.filter(key, vFilter[key]);
}

export default {
  components:{
    infoRecord
  },
  data() {
    return {
      keyName: "",
      tableData: [],
      pageSize: 10,
      currentPage: 1,
      total: 0,
      mySearchflag: false,
      fullscreenLoading: false,
      dialogRecordVisible:false,
      recordType:{},
    };
  },
  created() {
    if(this.$store.state.aliveStatus){
      this.currentPage =  this.$store.state.alivePage;
      this.keyName = sessionStorage.getItem('keyTel');
    }
    this.search();
    this.$store.commit("setAliveStatus", false);//取消列表页状态
    sessionStorage.removeItem('keyTel');
    this.$store.commit("setAlivePage", 1);//取消页码状态
  },
  activated() {
    // 重置数据
    this.keyName = this.$options.data().keyName;
    this.total = this.$options.data().total;
    this.tableData = this.$options.data().tableData;
    if(this.$store.state.aliveStatus){
      this.currentPage =  this.$store.state.alivePage;
      this.keyName = sessionStorage.getItem('keyTel');
    }
    this.search();
    this.$store.commit("setAliveStatus", false);//取消列表页状态
    sessionStorage.removeItem('keyTel');
    this.$store.commit("setAlivePage", 1);//取消页码状态
  },
  methods: {
    serviSurplus(val){
      this.$router.push('/basicDataCenter/baseSer=' + val.phone);
    },
    addBase(){
      this.$router.push('/basicDataCenter/baseAdd')
    },
    tableRowClassName({ row, column, rowIndex, columnIndex }) {
      //把每一行的索引放进row
      if (rowIndex%2 == 1) {
        return 'highLight';
      }
      return '';
    },
    specialCharacter() {
      this.keyName = this.keyName.replace(
        /[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘’，。、]/im,
        ""
      );
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    async search(val) {
      this.fullscreenLoading = true;
      if (val == 1) {
        this.currentPage = 1;
        this.$route.params.type ='';
      }
      let res = ''
      if(this.$route.params.type == 'birthday'){
        res = await queryMemberBirthPage({
          startDate: formatDate(new Date() , 'yyyy-MM-dd'),
          endDate: formatDate(new Date(new Date().getTime() + 3600 * 1000 * 24 * 30) ,'yyyy-MM-dd'),
          pageSize: this.pageSize,
          pageNumber: this.currentPage
        });
        this.fullscreenLoading = false;
        if (res.data.list.length == 0) {
          this.mySearchflag = true;
        }
        this.total = res.data.count;
        this.tableData = res.data.list;
        this.tableData.forEach(item => {
          if (item.memberBirth) {
            item.memberBirth = item.memberBirth.replace('-','月') + '日'
          }
        })
      }else{
        res = await searchMem({
          keyword: this.keyName,
          pageSize: this.pageSize,
          pageNumber: this.currentPage
        });
        this.fullscreenLoading = false;
        if (res.data.rows.length == 0) {
          this.mySearchflag = true;
        }
        this.total = res.data.total;
        this.tableData = res.data.rows;
        this.tableData.forEach(item => {
          if (item.memberBirth) {
            item.memberBirth = item.memberBirth.replace('-','月') + '日'
          }
        })
      }
    },
    enterSeach() {
      this.currentPage = 1;
      this.search();
    },
    addMemes() {
      // 添加会员
      this.$router.push("/basicDataCenter/addmems");
    },
    reset(memid, tel) {
      // 重设密码
      this.$alert(
        '<h2>确定要重设密码？</h2><p class="warning">重设密码必须由顾客本人提出并在场修改，否则产生的后果店员自行承担。</p><p>确定后系统将发送短信到顾客手机。</p>',
        "",
        {
          dangerouslyUseHTMLString: true,
          customClass: "memBox",
          showCancelButton: true,
          cancelButtonText: "关闭",
          cancelButtonClass: "darkBtn",
          confirmButtonClass: "redBtn",
          closeOnClickModal: true
        }
      )
        .then(({ value }) => {
          // 发送手机验证码到会员手机，并进入重设消费密码页
          let myData = {
            id: memid,
            tel: tel
          };
          sessionStorage.setItem("memInfo", JSON.stringify(myData));
          this.$store.commit("setVcode", true);//发送验证码
          this.$router.push("/basicDataCenter/resetPsd");
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "关闭"
          });
        });
    },
    editMem(id) {
      // 修改
      this.$router.push("/basicDataCenter/memId=" + id);
      this.$store.commit('setAlivePage',this.currentPage)
    },
    linkToDetail(row, column){
      if(column.property == 'memberId'){
        this.$router.push("/basicDataCenter/id=" + row.memberId);
        this.$store.commit('setAlivePage',this.currentPage)
      }
    },
    toDetail(type,data){
      this.dialogRecordVisible = true;
      this.recordType.type = type;
      this.recordType.memberId = data.memberId;
      this.recordType.name = data.name;
      this.recordType.phone = data.phone;
    },
    closeDialog(){
      this.dialogRecordVisible = false;
    },
    linkTo(row) {
      // 跳转会员详情
      this.$router.push("/basicDataCenter/id=" + row.memberId);
      this.$store.commit('setAlivePage',this.currentPage)
    }
  }
};
</script>
<style lang="less" scoped>
.main {
  padding: 25px 0;
  .infosearch {
    .el-input__inner {
      border-radius: 20px;
    }
    .searchBtn {
      width: 47px;
      height: 38px;
      background: #f83b56 url(../../assets/images/store/btn_datalist_search.png)
        no-repeat center;
    }
    .addMems {
      color: #fff;
      font-weight: bold;
      text-indent: 20px;
      background: #3b404f url(../../assets/images/store/btn_datalist_add.png)
        no-repeat 15px center;
    }
  }
  .myMemTable {
    margin-top: 25px;
    border: 1px solid #D5D9E3;
    .el-button--mini {
      padding: 8px;
      font-weight: bold;
    }
    .el-button + .el-button {
      margin-left: 0;
    }
  }
  .defaults,
  .emptys {
    height: 600px;
    background: url(../../assets/images/store/img_vip_inquire.png) no-repeat
      center;
    text-align: center;
    font-size: 15px;
    color: #666;
    padding-top: 450px;
  }
  .emptys {
    background: url(../../assets/images/store/img_vip_none.png) no-repeat center;
  }
}
</style>
<style lang="less">
.myMemTable {
  .operation {
    .cell {
      padding: 0;
    }
  }
  .el-table__header{
    background:rgb(239, 241, 245);
  }
  .highLight {
    background: #EFF1F5;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/basicDataCenter/baseInfo.vue